import Image, { StaticImageData } from 'next/image'

import CocSkinIcon from '@/assets/images/icons/coc_icon_cosmetics.png'
import CocGemIcon from '@/assets/images/icons/coc_icon_gem.png'
import CocScenerieIcon from '@/assets/images/icons/coc_icon_scenery.png'

import { ProductCardContentType } from '../card/CardSingleProduct'
import { StoreTypography } from '../typography/StoreTypography'

import styles from './ProductCategory.module.scss'

interface ProductCategoryHeaderProps {
  title: string
  type: ProductCardContentType
}

const icons: Partial<Record<ProductCardContentType, StaticImageData>> = {
  GEM: CocGemIcon,
  SEASON_PASS: CocGemIcon,
  ITEM: CocGemIcon,
  SKIN: CocSkinIcon,
  SCENERY: CocScenerieIcon,
} as const

export const ProductCategoryHeader = ({ title, type }: ProductCategoryHeaderProps) => {
  return (
    <div className={styles.Header}>
      <div className={styles.Icon}>
        {icons[type] && (
          <Image src={icons[type]} alt="category icon" fill sizes="50px" style={{ objectFit: 'contain' }} />
        )}
      </div>
      <StoreTypography tag="h2" textSize="md" style="outlined" className={styles.HeadingText}>
        {title}
      </StoreTypography>
    </div>
  )
}
